import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CCTVPage from './pages/CCTVPage';
import ROPage from './pages/ROPage';
import SEO from './components/SEO';

function App() {
  return (
    <Router>
      <SEO />
      <Routes>
        <Route path="/" element={<CCTVPage />} />
        <Route path="/cctv" element={<CCTVPage />} />
        <Route path="/ro" element={<ROPage />} />
      </Routes>
    </Router>
  );
}

export default App;

